import { createDuskApp, DUSK_CHAIN_PRESETS } from "@dusk/connect";
import { TESTNET_NODE, TESTNET_GRAPHQL, buildContractPresets } from "./chain-config.js";

let duskInstance = null;
let duskReadyPromise = null;

export function initChainApp(options = {}) {
  if (duskInstance) return duskInstance;
  duskInstance = createDuskApp({
    nodeUrl: TESTNET_NODE,
    chain: { chainId: DUSK_CHAIN_PRESETS.testnet },
    // Don't auto-prompt connect on writeContract - user clicks Connect.
    // Wallet.autoRefresh (Connect default true) restores an already-
    // authorized extension session on reload without a new prompt.
    autoConnect: false,
    contracts: buildContractPresets(),
    ...options,
  });
  return duskInstance;
}

export async function getChainApp() {
  if (!duskInstance) initChainApp();
  if (!duskReadyPromise) duskReadyPromise = duskInstance.ready();
  await duskReadyPromise;
  return duskInstance;
}

export function getWallet() {
  return duskInstance?.wallet ?? null;
}

export async function getBlockHeight() {
  const res = await fetch(TESTNET_GRAPHQL, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: "{ lastBlockPair { json } }",
  });
  if (!res.ok) throw new Error(`GraphQL failed: ${res.status}`);
  const body = await res.json();
  const pair = (body.data?.lastBlockPair ?? body.lastBlockPair)?.json?.last_finalized_block;
  if (!Array.isArray(pair) || typeof pair[0] !== "number") {
    throw new Error("Unexpected lastBlockPair shape");
  }
  return pair[0];
}
